/**
 * Champs du modèle ProductTranslation disponibles en base de données.
 */
export const PRODUCT_TRANSLATION_FIELDS = [
  'name',
  'slug',
  'short_description',
  'long_description',
  'description_intro',
  'description_bullet',
  'description_end',
  'seo_h1',
  'seo_title',
  'seo_description',
];

/**
 * Transformations qui nécessitent la sélection d'un champ source
 */
export const TRANSFORMATIONS_WITH_SOURCE_FIELD = [
  'add_prefix',
  'add_suffix',
  'add_prefix_suffix',
  'multiply',
  'divide',
  'translate',
  'uppercase',
  'lowercase',
  'truncate',
];

/**
 * Options de requête pour les attributs (AttributeList)
 */
export const REQUIREMENT_OPTIONS = [
  {
    color: 'red',
    label: 'Attribut obligatoire',
    name: 'required',
  },
  {
    color: 'yellow',
    label: 'Attribut conseillé',
    name: 'recommended',
  },
  {
    color: 'green',
    label: 'Attribut optionnel',
    name: 'optional',
  },
  {
    color: 'gray',
    label: 'Non renseigné',
    name: 'not_provided',
  },
];

export const MOCK_MAPPING = [
  {
    key: '1',
    level: 1,
    targetField: 'feature_06575_brand',
    sourceField: 'brand',
    mappingType: 'transformation',
  },
  {
    key: '2',
    level: 3,
    targetField: 'slug',
    sourceField: 'parentproductid',
    mappingType: 'simple',
  },
  {
    key: '3',
    level: 1,
    targetField: 'i18n_it_01022_longdescription',
    sourceField: 'short_description, long_descript',
    mappingType: 'simple',
  },
  {
    key: '4',
    level: 1,
    targetField: 'shop_sku',
    sourceField: 'reference',
    mappingType: 'transformation',
  },
  {
    key: '5',
    level: 2,
    targetField: 'composition',
    sourceField: 'non mappé',
    mappingType: null,
  },
  {
    key: '6',
    level: 2,
    targetField: 'name',
    sourceField: 'champ source',
    mappingType: 'simple',
  },
];

export const MARKETPLACE_OPTIONS = [
  { label: 'Leroy Merlin', value: 'leroymerlin' },
  { label: 'ManoMano', value: 'manomano' },
];

export const STORE_OPTIONS = [
  { label: 'France', value: 'fr' },
  { label: 'Spain', value: 'es' },
  { label: 'Italy', value: 'it' },
  { label: 'Portugal', value: 'pt' },
  { label: 'Poland', value: 'pl' },
];

export const MOCK_MAPPING_LIST = [
  {
    key: '1',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin France',
    store: 'France',
    category: 'Parasol & Ombrage',
    mp_category: 'Parasol & Ombrage',
  },
  {
    key: '2',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Spain',
    store: 'Spain',
    category: 'Parasol & Ombrage',
    mp_category: 'Parasol & Ombrage',
  },
  {
    key: '3',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Italy',
    store: 'Italy',
    category: 'Parasol & Ombrage',
    mp_category: 'Parasol & Ombrage',
  },
  {
    key: '4',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Portugal',
    store: 'Portugal',
    category: 'Parasol & Ombrage',
    mp_category: 'Parasol & Ombrage',
  },
  {
    key: '5',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Poland',
    store: 'Poland',
    category: 'Parasol & Ombrage',
    mp_category: 'Parasol & Ombrage',
  },
  {
    key: '6',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin France',
    store: 'France',
    category: 'Mobilier de jardin',
    mp_category: 'Mobilier de jardin',
  },
  {
    key: '7',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Spain',
    store: 'Spain',
    category: 'Mobilier de jardin',
    mp_category: 'Mobilier de jardin',
  },
  {
    key: '8',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Italy',
    store: 'Italy',
    category: 'Mobilier de jardin',
    mp_category: 'Mobilier de jardin',
  },
  {
    key: '9',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin France',
    store: 'France',
    category: 'Outillage',
    mp_category: 'Outillage électroportatif',
  },
  {
    key: '10',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Spain',
    store: 'Spain',
    category: 'Outillage',
    mp_category: 'Outillage électroportatif',
  },
  {
    key: '11',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Portugal',
    store: 'Portugal',
    category: 'Décoration',
    mp_category: 'Décoration intérieure',
  },
  {
    key: '12',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Poland',
    store: 'Poland',
    category: 'Décoration',
    mp_category: 'Décoration intérieure',
  },
  {
    key: '13',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin France',
    store: 'France',
    category: 'Éclairage',
    mp_category: 'Éclairage extérieur',
  },
  {
    key: '14',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Italy',
    store: 'Italy',
    category: 'Éclairage',
    mp_category: 'Éclairage intérieur',
  },
  {
    key: '15',
    marketplace: 'leroymerlin',
    marketplaceLabel: 'Leroy Merlin Spain',
    store: 'Spain',
    category: 'Plomberie',
    mp_category: 'Plomberie sanitaire',
  },
];

// ============================================================================
// CONSTANTES POUR L'UI DES TYPES DE MAPPING (AttributeList)
// ============================================================================

export const MAPPING_TYPE_UI = {
  simple: {
    label: 'Mapping Simple',
    color: 'blue',
    icon: 'simple',
  },
  unique: {
    label: 'Transformation unique',
    color: 'red',
    icon: 'unique',
  },
  chain: {
    label: 'Chaine de transformations',
    color: 'red',
    icon: 'chain',
  },
  none: {
    label: 'Non configuré',
    color: 'gray',
    icon: 'none',
  },
};

/**
 * Liste des opérateurs de comparaison disponibles pour les conditions simples
 */
export const CONDITION_OPERATORS = [
  { value: 'equals', label: 'Égal à', category: 'numeric' },
  { value: 'not_equals', label: 'Différent de', category: 'numeric' },

  {
    value: 'str_equals',
    label: 'Égal à',
    category: 'string',
  },
  {
    value: 'str_i_equals',
    label: 'Égal à - chaîne insensible à la casse (Majuscules/Minuscules)',
    category: 'string',
  },
  { value: 'greater_than', label: 'Supérieur à', category: 'numeric' },
  { value: 'less_than', label: 'Inférieur à', category: 'numeric' },
  {
    value: 'greater_than_or_equal',
    label: 'Supérieur ou égal à',
    category: 'numeric',
  },
  {
    value: 'less_than_or_equal',
    label: 'Inférieur ou égal à',
    category: 'numeric',
  },
  { value: 'contains', label: 'Contient', category: 'string' },
  { value: 'not_contains', label: 'Ne contient pas', category: 'string' },
  { value: 'startswith', label: 'Commence par', category: 'string' },
  { value: 'endswith', label: 'Se termine par', category: 'string' },
  { value: 'in', label: 'Dans la liste', category: 'list' },
  { value: 'not_in', label: 'Pas dans la liste', category: 'list' },

  {
    value: 'and',
    label: 'ET (toutes les conditions doivent être vraies)',
    category: 'logical',
  },
  {
    value: 'or',
    label: 'OU (au moins une condition doit être vraie)',
    category: 'logical',
  },
];

// ============================================================================
// CONSTANTES POUR LES TYPES DE TRANSFORMATIONS
// ============================================================================

/**
 * Liste des types de transformations disponibles
 */
export const TRANSFORMATION_TYPES = [
  {
    value: 'uppercase',
    label: 'Mettre en majuscules',
    description: 'Convertit le texte en majuscules',
    params: [],
  },
  {
    value: 'lowercase',
    label: 'Mettre en minuscules',
    description: 'Convertit le texte en minuscules',
    params: [],
  },
  {
    value: 'multiply',
    label: 'Multiplier',
    description: 'Multiplie la valeur numérique par un facteur',
    params: [
      { name: 'factor', type: 'number', label: 'Facteur', required: true },
    ],
  },
  {
    value: 'divide',
    label: 'Diviser',
    description: 'Divise la valeur numérique par un facteur',
    params: [
      { name: 'divisor', type: 'number', label: 'Diviseur', required: true },
    ],
  },
  {
    value: 'set_value',
    label: 'Définir une valeur',
    description: 'Remplace la valeur par une valeur fixe',
    params: [{ name: 'value', type: 'any', label: 'Valeur', required: true }],
  },
  {
    value: 'add_prefix',
    label: 'Ajouter un préfixe',
    description: 'Ajoute un texte au début de la valeur',
    params: [
      { name: 'prefix', type: 'string', label: 'Préfixe', required: true },
    ],
  },
  {
    value: 'add_suffix',
    label: 'Ajouter un suffixe',
    description: 'Ajoute un texte à la fin de la valeur',
    params: [
      { name: 'suffix', type: 'string', label: 'Suffixe', required: true },
    ],
  },
  {
    value: 'add_prefix_suffix',
    label: 'Ajouter préfixe et suffixe',
    description: 'Ajoute un texte au début et à la fin de la valeur',
    params: [
      { name: 'prefix', type: 'string', label: 'Préfixe', required: true },
      { name: 'suffix', type: 'string', label: 'Suffixe', required: true },
    ],
  },
  {
    value: 'concatenate',
    label: 'Concaténer',
    description: 'Concatène plusieurs champs avec un délimiteur',
    params: [
      { name: 'fields', type: 'array', label: 'Champs', required: true },
      {
        name: 'delimiter',
        type: 'string',
        label: 'Délimiteur',
        required: false,
      },
    ],
  },
  {
    value: 'get_attribute',
    label: 'Obtenir un attribut',
    description: 'Récupère un attribut spécifique',
    params: [
      { name: 'attr', type: 'string', label: 'Attribut', required: true },
    ],
  },
  {
    value: 'set_first_attribute_value',
    label: 'Première valeur disponible',
    description: "Utilise la première valeur non nulle d'une liste de champs",
    params: [
      {
        name: 'fields',
        type: 'array',
        label: 'Liste de champs',
        required: true,
      },
    ],
  },
  {
    value: 'set_media_value',
    label: 'Valeur média',
    description: "Récupère l'URL d'un média selon son type et son ordre",
    params: [
      {
        name: 'media_type',
        type: 'string',
        label: 'Type de média',
        required: true,
      },
      {
        name: 'image_order',
        type: 'number',
        label: "Ordre de l'image",
        required: true,
      },
      {
        name: 'tags',
        type: 'array',
        label: 'Tags',
        required: false,
      },
    ],
  },
  {
    value: 'translate',
    label: 'Traduire',
    description: 'Traduire le texte en fonction de la langue',
    params: [
      {
        name: 'source_language',
        type: 'string',
        label: 'Langue source',
        required: true,
      },
      {
        name: 'destination_language',
        type: 'string',
        label: 'Langue de destination',
        required: true,
      },
    ],
  },
  {
    value: 'list',
    label: 'Liste de valeurs',
    description: 'Génère une liste de valeurs',
    params: [
      { name: 'elements', type: 'array', label: 'Éléments', required: true },
    ],
  },
  {
    value: 'truncate',
    label: 'Tronquer',
    description:
      'Tronque la chaîne au dernier mot complet avant la limite définie',
    params: [
      {
        name: 'length',
        type: 'number',
        label: 'Longueur maximale',
        required: true,
      },
    ],
  },
];

// ============================================================================
// CONSTANTES POUR LES TYPES DE RÈGLES DE TRANSFORMATION
// ============================================================================

/**
 * Types de règles de transformation
 */
export const TRANSFORMATION_RULE_TYPES = [
  {
    value: 'unique_transformation',
    label: 'Transformation unique',
    description: 'Une seule transformation avec condition optionnelle',
  },
  {
    value: 'transformation_chain',
    label: 'Chaîne de transformations (if-elif-else)',
    description: 'Plusieurs transformations avec conditions (if-elif-else)',
  },
];

export const MAPPING_TYPES_UI = {
  unique: {
    label: 'Transformation unique',
    color: 'red',
    icon: 'thunderbolt',
  },
  chain: {
    label: 'Chaine de transformations',
    color: 'red',
    icon: 'thunderbolt',
  },
  simple: {
    label: 'Mapping Simple',
    color: 'blue',
    icon: 'link',
  },
  none: {
    label: 'Non mappé',
    color: 'gray',
    icon: null,
  },
};

// ============================================================================
// CONSTANTES POUR LES TYPES DE CHAMPS DANS LA CONCATÉNATION
// ============================================================================

/**
 * Types de champs utilisables dans la concaténation
 */
export const CONCATENATE_FIELD_TYPES = [
  {
    value: 'attribute',
    label: 'Attribut',
    description: 'Référence à un attribut du produit',
  },
  {
    value: 'freetext',
    label: 'Texte libre',
    description: 'Texte fixe à insérer',
  },
];

/**
 * Fonction helper pour obtenir le label d'un opérateur
 */
export const getOperatorLabel = (operatorValue) => {
  const operator = CONDITION_OPERATORS.find((op) => op.value === operatorValue);
  return operator ? operator.label : operatorValue;
};

/**
 * Fonction helper pour obtenir le label d'un type de transformation
 */
export const getTransformationTypeLabel = (typeValue) => {
  const type = TRANSFORMATION_TYPES.find((t) => t.value === typeValue);
  return type ? type.label : typeValue;
};

/**
 * Fonction helper pour obtenir les paramètres requis d'un type de transformation
 */
export const getTransformationParams = (typeValue) => {
  const type = TRANSFORMATION_TYPES.find((t) => t.value === typeValue);
  return type ? type.params : [];
};

/**
 * Fonction helper pour calculer le niveau d'imbrication d'une condition
 */
export const calculateNestingLevel = (condition, currentLevel = 0) => {
  if (!condition || currentLevel > 5) {
    return currentLevel;
  }

  if (
    condition.operator &&
    condition.conditions &&
    Array.isArray(condition.conditions)
  ) {
    const maxChildLevel = Math.max(
      ...condition.conditions.map((child) =>
        calculateNestingLevel(child, currentLevel + 1)
      )
    );
    return maxChildLevel;
  }

  return currentLevel;
};
export const MOCK_MAPPING_CONFIG_LR = {
  field_mappings: [
    {
      source_field: null,
      target_field: 'product_category',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'parentproductid',
      destination_language: 'fr',
    },
    {
      source_field: 'reference',
      target_field: 'shop_sku',
      destination_language: 'fr',
    },
    {
      source_field: 'ean13',
      target_field: 'gtin_EAN13',
      destination_language: 'fr',
    },
    {
      source_field: 'brand',
      target_field: 'feature_06575_brand',
      destination_language: 'fr',
    },
    {
      source_field: 'name',
      target_field: 'i18n_fr_12963_title',
      destination_language: 'fr',
    },
    {
      source_field: 'name',
      target_field: 'i18n_it_12963_title',
      destination_language: 'it',
    },
    {
      source_field: 'name',
      target_field: 'i18n_es_12963_title',
      destination_language: 'es',
    },
    {
      source_field: 'name',
      target_field: 'i18n_pt_12963_title',
      destination_language: 'pt',
    },
    {
      source_field: 'name',
      target_field: 'i18n_pl_12963_title',
      destination_language: 'pl',
    },
    {
      source_field: null,
      target_field: 'i18n_fr_01022_longdescription',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'i18n_it_01022_longdescription',
      destination_language: 'it',
    },
    {
      source_field: null,
      target_field: 'i18n_es_01022_longdescription',
      destination_language: 'es',
    },
    {
      source_field: null,
      target_field: 'i18n_pt_01022_longdescription',
      destination_language: 'pt',
    },
    {
      source_field: null,
      target_field: 'i18n_pl_01022_longdescription',
      destination_language: 'pl',
    },
    { source_field: null, target_field: 'media_1', destination_language: 'fr' },
    { source_field: null, target_field: 'media_2', destination_language: 'fr' },
    { source_field: null, target_field: 'media_3', destination_language: 'fr' },
    { source_field: null, target_field: 'media_4', destination_language: 'fr' },
    { source_field: null, target_field: 'media_5', destination_language: 'fr' },
    { source_field: null, target_field: 'media_6', destination_language: 'fr' },
    { source_field: null, target_field: 'media_7', destination_language: 'fr' },
    { source_field: null, target_field: 'media_8', destination_language: 'fr' },
    { source_field: null, target_field: 'media_9', destination_language: 'fr' },
    {
      source_field: null,
      target_field: 'media_1_it-IT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_2_it-IT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_3_it-IT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_4_it-IT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_1_es-ES',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_2_es-ES',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_3_es-ES',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_4_es-ES',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_1_pt-PT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_2_pt-PT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_3_pt-PT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_4_pt-PT',
      destination_language: 'fr',
    },
    {
      source_field: 'main_color.name',
      target_field: 'feature_10837_main_color',
      destination_language: 'it',
    },
    {
      source_field: 'main_material.name',
      target_field: 'feature_10840_main_material',
      destination_language: 'it',
    },
    {
      source_field: null,
      target_field: 'media_instruction',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_instruction_it-IT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_instruction_es-ES',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'media_instruction_pt-PT',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'ATT_15344',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'ATT_21148',
      destination_language: 'fr',
    },
    {
      source_field: 'width',
      target_field: 'ATT_00053',
      destination_language: 'fr',
    },
    {
      source_field: 'height',
      target_field: 'ATT_00054',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_00562_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_08547_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_01181_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: 'motorization_type',
      target_field:
        'feature_06782_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'ATT_09344',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'ATT_05885',
      destination_language: 'fr',
    },
    {
      source_field: 'height',
      target_field: 'ATT_16936',
      destination_language: 'fr',
    },
    {
      source_field: 'width',
      target_field: 'ATT_16937',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_10777_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_10774_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: 'color_structure',
      target_field:
        'feature_01746_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_06784_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: 'product_filling',
      target_field:
        'feature_13407_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_22088_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: 'width',
      target_field: 'ATT_13411',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'ATT_22040',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field:
        'feature_10842_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
      destination_language: 'fr',
    },
    {
      source_field: null,
      target_field: 'feature_12962_206244|2190|R08-011-004',
      destination_language: 'fr',
    },
    {
      source_field: 'width',
      target_field: 'ATT_00053',
      destination_language: 'fr',
    },
    {
      source_field: 'height',
      target_field: 'ATT_00054',
      destination_language: 'fr',
    },
    {
      source_field: 'width',
      target_field: 'ATT_00055',
      destination_language: 'fr',
    },
  ],
  transformation_rules: [
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'product_category',
          type: 'set_value',
          params: {
            value: '201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
          },
        },
      },
    },
    {
      transformation_chain: [
        {
          condition: {
            field: 'brand',
            value: 'casanoov',
            operator: 'equals',
          },
          transformation: {
            type: 'concatenate',
            field: 'i18n_fr_01022_longdescription',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'short_description',
                },
                {
                  type: 'freetext',
                  value:
                    'Casanoov est spécialisé dans les portails et portillons en KIT, à asssembler et à poser soi-même',
                },
                {
                  type: 'attribute',
                  value: 'long_description',
                },
              ],
              destination_language: 'fr',
              delimiter: ' ',
            },
          },
        },
        {
          condition: {
            field: 'brand',
            value: 'cazeboo',
            operator: 'equals',
          },
          transformation: {
            type: 'concatenate',
            field: 'i18n_fr_01022_longdescription',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'short_description',
                },
                {
                  type: 'freetext',
                  value:
                    'Cazeboo est spécialisé dans la pergola, le carport et la tonnelle en KIT, à assembler et à poser soi-même',
                },
                {
                  type: 'attribute',
                  value: 'long_description',
                },
              ],
              destination_language: 'fr',
              delimiter: ' ',
            },
          },
        },
        {
          condition: {
            field: 'brand',
            value: 'sicaan',
            operator: 'equals',
          },
          transformation: {
            type: 'concatenate',
            field: 'i18n_fr_01022_longdescription',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'short_description',
                },
                {
                  type: 'freetext',
                  value:
                    'Sicaan, votre partenaire privilégié pour des fauteuils, canapés, et poufs en kit de qualité',
                },
                {
                  type: 'attribute',
                  value: 'long_description',
                },
              ],
              destination_language: 'fr',
              delimiter: ' ',
            },
          },
        },
      ],
    },
    {
      transformation_chain: [
        {
          condition: {
            field: 'brand',
            value: 'casanoov',
            operator: 'equals',
          },
          transformation: {
            type: 'concatenate',
            field: 'i18n_it_01022_longdescription',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'short_description',
                },
                {
                  type: 'freetext',
                  value:
                    'Casanoov è specializzata in cancelli fai da te e kit per cancelli pedonali.',
                },
                {
                  type: 'attribute',
                  value: 'long_description',
                },
              ],
              destination_language: 'it',
              delimiter: ' ',
            },
          },
        },
        {
          condition: {
            field: 'brand',
            value: 'cazeboo',
            operator: 'equals',
          },
          transformation: {
            type: 'concatenate',
            field: 'i18n_it_01022_longdescription',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'short_description',
                },
                {
                  type: 'freetext',
                  value:
                    'Cazeboo è specializzata in kit per pergole, carport e gazebo, da montare e installare autonomamente.',
                },
                {
                  type: 'attribute',
                  value: 'long_description',
                },
              ],
              destination_language: 'it',
              delimiter: ' ',
            },
          },
        },
        {
          condition: {
            field: 'brand',
            value: 'sicaan',
            operator: 'equals',
          },
          transformation: {
            type: 'concatenate',
            field: 'i18n_it_01022_longdescription',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'short_description',
                },
                {
                  type: 'freetext',
                  value:
                    'Sicaan, il tuo partner preferito per poltrone, divani e pouf di qualità in kit',
                },
                {
                  type: 'attribute',
                  value: 'long_description',
                },
              ],
              destination_language: 'it',
              delimiter: ' ',
            },
          },
        },
      ],
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_1',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_2',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 1,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_3',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 2,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_4',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 3,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_5',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 4,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_6',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 5,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_7',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 6,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_8',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 7,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_9',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 8,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_1_it-IT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_2_it-IT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 1,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_3_it-IT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 2,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_4_it-IT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 3,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_1_es-ES',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_2_es-ES',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 1,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_3_es-ES',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 2,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_4_es-ES',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 3,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_1_pt-PT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_2_pt-PT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 1,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_3_pt-PT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 2,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_4_pt-PT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'image',
            image_order: 3,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_instruction',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'document',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_instruction_it-IT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'document',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_instruction_es-ES',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'document',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'media_instruction_pt-PT',
          type: 'set_media_value',
          params: {
            value: null,
            media_type: 'document',
            image_order: 0,
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'ATT_15344',
          type: 'set_value',
          params: {
            value: 'Non',
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field: 'ATT_21148',
          type: 'set_value',
          params: {
            value: 'Non',
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field:
            'feature_00562_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
          type: 'set_value',
          params: {
            value: 'Droit',
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field:
            'feature_08547_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
          type: 'set_value',
          params: {
            value: 'Portail',
          },
        },
      },
    },
    {
      transformation_chain: [
        {
          condition: {
            operator: 'str_i_equals',
            field: 'motorization_has',
            value: 'Yes',
          },
          transformation: {
            type: 'concatenate',
            field:
              'feature_01181_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'product_opening_system',
                },
                {
                  type: 'freetext',
                  value: 'motorisé',
                },
              ],
              delimiter: ' ',
            },
          },
        },
        {
          condition: {
            operator: 'str_i_equals',
            field: 'motorization_has',
            value: 'No',
          },
          transformation: {
            type: 'set_first_attribute_value',
            field:
              'feature_01181_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            params: {
              fields: [
                {
                  type: 'attribute',
                  value: 'product_opening_system',
                },
              ],
            },
          },
        },
        {
          default_transformation: {
            type: 'set_value',
            field:
              'feature_01181_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            params: {
              value: 'Battant',
            },
          },
        },
      ],
    },
    {
      transformation_chain: [
        {
          condition: {
            operator: 'str_i_equals',
            field: 'motorization_compatibility',
            value: 'Yes',
          },
          transformation: {
            field: 'ATT_09344',
            type: 'set_value',
            params: {
              value: 'Oui',
            },
          },
        },
        {
          condition: {
            operator: 'str_i_equals',
            field: 'motorization_compatibility',
            value: 'No',
          },
          transformation: {
            field: 'ATT_09344',
            type: 'set_value',
            params: {
              value: 'Non',
            },
          },
        },
        {
          default_transformation: {
            type: 'set_value',
            field: 'ATT_09344',
            params: {
              value: 'Non',
            },
          },
        },
      ],
    },
    {
      transformation_chain: [
        {
          condition: {
            operator: 'str_i_equals',
            field: 'color_structure',
            value: 'Black',
          },
          transformation: {
            field: 'ATT_05885',
            type: 'set_value',
            params: {
              value: 'LOV_001063',
            },
          },
        },
        {
          condition: {
            operator: 'str_i_equals',
            field: 'color_structure',
            value: 'Charcoal grey',
          },
          transformation: {
            field: 'ATT_05885',
            type: 'set_value',
            params: {
              value: 'LOV_038355',
            },
          },
        },
        {
          condition: {
            operator: 'str_i_equals',
            field: 'color_structure',
            value: 'Green',
          },
          transformation: {
            field: 'ATT_05885',
            type: 'set_value',
            params: {
              value: 'LOV_003696',
            },
          },
        },
        {
          default_transformation: {
            type: 'set_value',
            field: 'ATT_05885',
            params: {
              value: 'LOV_038355',
            },
          },
        },
      ],
    },
    {
      transformation_chain: [
        {
          condition: {
            operator: 'and',
            conditions: [
              {
                operator: 'greater_than_or_equal',
                field: 'height',
                value: 0,
              },
              {
                operator: 'less_than',
                field: 'height',
                value: 140,
              },
            ],
          },
          transformation: {
            field:
              'feature_10777_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'Moins de 140',
            },
          },
        },
        {
          condition: {
            operator: 'and',
            conditions: [
              {
                operator: 'greater_than_or_equal',
                field: 'height',
                value: 140,
              },
              {
                operator: 'less_than',
                field: 'height',
                value: 160,
              },
            ],
          },
          transformation: {
            field:
              'feature_10777_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'De 140 à 159',
            },
          },
        },
        {
          condition: {
            operator: 'and',
            conditions: [
              {
                operator: 'greater_than_or_equal',
                field: 'height',
                value: 160,
              },
              {
                operator: 'less_than',
                field: 'height',
                value: 179,
              },
            ],
          },
          transformation: {
            field:
              'feature_10777_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'De 160 à 179',
            },
          },
        },
        {
          condition: {
            operator: 'greater_than_or_equal',
            field: 'height',
            value: 180,
          },
          transformation: {
            field:
              'feature_10777_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'Supérieure ou égale à 180',
            },
          },
        },
        {
          default_transformation: {
            field:
              'feature_10777_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'Moins de 140',
            },
          },
        },
      ],
    },
    {
      transformation_chain: [
        {
          condition: {
            operator: 'and',
            conditions: [
              {
                operator: 'greater_than_or_equal',
                field: 'width',
                value: 0,
              },
              {
                operator: 'less_than',
                field: 'width',
                value: 350,
              },
            ],
          },
          transformation: {
            field:
              'feature_10774_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'Moins de 350',
            },
          },
        },
        {
          condition: {
            operator: 'and',
            conditions: [
              {
                operator: 'greater_than_or_equal',
                field: 'width',
                value: 350,
              },
              {
                operator: 'less_than',
                field: 'width',
                value: 400,
              },
            ],
          },
          transformation: {
            field:
              'feature_10774_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'De 350 à 399',
            },
          },
        },
        {
          condition: {
            operator: 'and',
            conditions: [
              {
                operator: 'greater_than_or_equal',
                field: 'width',
                value: 400,
              },
              {
                operator: 'less_than',
                field: 'width',
                value: 450,
              },
            ],
          },
          transformation: {
            field:
              'feature_10774_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'De 400 à 449',
            },
          },
        },
        {
          condition: {
            operator: 'greater_than_or_equal',
            field: 'width',
            value: 450,
          },
          transformation: {
            field:
              'feature_10774_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'Supérieure ou égale à 450',
            },
          },
        },
        {
          default_transformation: {
            field:
              'feature_10774_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
            type: 'set_value',
            params: {
              value: 'Moins de 350',
            },
          },
        },
      ],
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field:
            'feature_06784_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
          type: 'set_value',
          params: {
            value: 'Non',
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: null,
        transformation: {
          field:
            'feature_22088_201434|PORTAIL|PORTAIL_ET_PORTILLON|R09-014-003',
          type: 'set_value',
          params: {
            value: 'Portail',
          },
        },
      },
    },
    {
      unique_transformation: {
        condition: {
          operator: 'str_i_equals',
          field: 'motorization_has',
          value: 'Yes',
        },
        transformation: {
          field: 'ATT_22040',
          type: 'set_value',
          params: {
            value: 'Radio-fréquence',
          },
        },
      },
    },
  ],
};
